<template>
  <div class="service-cases">
    <!-- 视差背景横幅 -->
    <div class="parallax-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <h1 class="animate__animated animate__fadeInDown">服务案例</h1>
        <p class="animate__animated animate__fadeInUp">SERVICE CASES</p>
      </div>
    </div>

    <div class="case-content" v-loading="loading">
      <div class="content-container">
        <el-tabs v-model="activeTab" @tab-click="tabClick">
          <el-tab-pane name="0" label="部分客户"></el-tab-pane>
        </el-tabs>

        <el-empty description="暂无内容" v-show="isEmpty"></el-empty>

        <div class="case-grid">
          <div class="case-card" v-for="(caseItem, index) in caseItems" :key="index">
            <div class="card-image">
              <img :src="caseItem.fileUrls" :alt="caseItem.title">
            </div>
            <div class="card-body">
              <h3>{{ caseItem.title }}</h3>
            </div>
          </div>
        </div>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCases"
          class="pagination">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.service-cases {
  background: #fff;

  // 视差背景横幅
  .parallax-banner {
    height: 35vh;
    background: url('../assets/img/bgtop.jpg') center/cover fixed;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }

    .banner-content {
      position: relative;
      z-index: 1;

      h1 {
        font-size: 3rem;
        margin-bottom: 1rem;
        font-weight: 600;
      }

      p {
        font-size: 1.1rem;
        letter-spacing: 0.3rem;
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  .case-content {
    margin-top: -40px;
    position: relative;
    z-index: 2;
    padding: 0 0 6rem;

    .content-container {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 2rem;
      background: white;
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

      :deep(.el-tabs__nav-wrap) {
        &::after {
          height: 0;
        }
      }

      :deep(.el-tabs__nav) {
        display: flex;
        justify-content: center;
        gap: 4rem;
        padding: 2rem 0;
      }

      :deep(.el-tabs__item) {
        font-size: 1.2rem;
        padding: 0 1rem;
        height: 50px;
        line-height: 50px;
        transition: all 0.3s ease;
        border: none;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 3px;
          background: #409EFF;
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        &.is-active {
          color: #409EFF;
          font-weight: 600;

          &::after {
            transform: scaleX(1);
          }
        }

        &:hover {
          color: #409EFF;
        }
      }

      .case-grid {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 2rem;
        margin: 3rem 0;
      }

      .case-card {
        background: white;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid #f0f0f0;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(64, 158, 255, 0.1);

          .card-image {
            &::after {
              opacity: 1;
            }

            img {
              transform: scale(1.05);
            }
          }

          .card-body h3 {
            color: #409EFF;
          }
        }

        .card-image {
          height: 160px;
          overflow: hidden;
          position: relative;
          padding: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;

          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(to bottom, rgba(64, 158, 255, 0.1), transparent);
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            transition: transform 0.3s ease;
          }
        }

        .card-body {
          padding: 1rem;
          background: white;
          border-top: 1px solid #f0f0f0;

          h3 {
            font-size: 1rem;
            color: #2c3e50;
            margin: 0;
            font-weight: 500;
            line-height: 1.4;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            transition: color 0.3s ease;
          }
        }
      }

      .pagination {
        text-align: center;
        margin-top: 4rem;
        padding-bottom: 2rem;

        :deep(.el-pagination button) {
          background: none;
          border: 1px solid #eaeaea;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            border-color: #409EFF;
          }
        }

        :deep(.el-pager li) {
          border: 1px solid #eaeaea;
          margin: 0 5px;
          transition: all 0.3s ease;
          
          &.active {
            background: #409EFF;
            color: white;
            border-color: #409EFF;
          }

          &:hover {
            color: #409EFF;
            border-color: #409EFF;
          }
        }
      }

      :deep(.el-tabs__active-bar) {
        display: none !important;
      }
    }
  }

  @media (max-width: 1400px) {
    .case-content .content-container {
      .case-grid {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }

  @media (max-width: 1200px) {
    .case-content .content-container {
      .case-grid {
        grid-template-columns: repeat(3, 1fr);
      }

      :deep(.el-tabs__nav) {
        gap: 2rem;
      }
    }
  }

  @media (max-width: 1200px) {
    .parallax-banner {
      height: 25vh!important;
    }
  }

  @media (max-width: 768px) {
    .parallax-banner {
      height: 25vh;

      .banner-content {
        h1 {
          font-size: 2.2rem;
        }

        p {
          font-size: 0.9rem;
        }
      }
    }

    .case-content {
      margin-top: -40px;
      padding: 0 0 4rem;

      .content-container {
        padding: 0 1rem;

        :deep(.el-tabs__nav) {
          gap: 1rem;
        }

        :deep(.el-tabs__item) {
          font-size: 1rem;
          padding: 0 0.5rem;
        }

        .case-grid {
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
          margin: 2rem 0;
        }

        .case-card {
          .card-image {
            height: 140px;
          }

          .card-body {
            padding: 0.8rem;
          }
        }

        .pagination {
          margin-top: 2rem;
        }
      }
    }
  }
}

// 动画类
.animate__animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.animate__fadeInDown {
  animation-name: fadeInDown;
}

.animate__fadeInUp {
  animation-name: fadeInUp;
}
</style>

<script>
export default {
  name: "CaseList",
  data() {
    return {
      isEmpty: false,
      activeTab: '0',
      caseItems: [],
      currentPage: 1,
      pageSize: 25,
      totalCases: 20,
      busList: [],
      loading: true
    };
  },
  methods: {
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getCase();
    },
    tabClick(item) {
      this.activeTab = item.name;
      this.getCase();
    },
    loadData() {
      this.$http
        .get(`business/list`)
        .then(response => {
          this.busList = response.data.data;
          this.activeTab = "0";
          this.loading = false;
          this.getCase();
        })
        .catch(function(error) {
          window.console.log(error);
        });
    },
    getCase() {
      this.caseItems = [];
      if (this.activeTab == 0) {
        this.$http
          .get(`case/page?pageNo=${this.currentPage}&pageSize=${this.pageSize}`)
          .then(response => {
            this.caseItems = response.data.data.list;
            this.totalCases = response.data.data.total;
            if (this.totalCases == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            for (let obj of this.caseItems) {
              obj.fileUrls = this.imgserver + obj.fileUrls.split(",")[0];
            }
          })
          .catch(function(error) {
            window.console.log(error);
          });
      } else {
        this.$http
          .get(`case/page?bId=${this.activeTab}&pageNo=${this.currentPage}&pageSize=${this.pageSize}`)
          .then(response => {
            this.totalCases = response.data.data.total;
            this.caseItems = response.data.data.list;
            if (this.totalCases == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            for (let obj of this.caseItems) {
              obj.fileUrls = this.imgserver + obj.fileUrls.split(",")[0];
            }
          })
          .catch(function(error) {
            window.console.log(error);
          });
      }
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

  
  